/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const ExploreTags = ({ sectionContent, region, lang }) => {
  // Extracting the text content and buttons from sectionContent
  const textContent = sectionContent.find(
    item => item._modelApiKey === 'structured_text'
  );
  const buttons = sectionContent.filter(
    item => item._modelApiKey === 'simple_button'
  );

  // Extract the text value from the structured_text content
  const textValue = textContent
    ? textContent.body.value.document.children[0].children[0].value
    : '';

  return (
    <Box
      width={'100%'}
      bg="#292929"
      p={8}
      mb="50px"
      // mt={{ '2xl': '-10rem' }}
      color="#FEFAF6"
      bgColor={'#0E1216'}
      textAlign={'center'}
    >
      <Flex
        w="100%"
        flexDirection={{ base: 'column', md: 'row' }}
        alignItems="center"
        justifyContent="center"
        gap={8}
      >
        <Text
          fontSize={{ md: '1.25rem', base: '1.125rem' }}
          fontWeight="500"
          fontFamily={'var(--FedraSansStd-medium)'}
          lineHeight={{ md: '2rem', base: '1.8rem' }}
          letterSpacing="2%"
          whiteSpace="nowrap"
        >
          {textValue}
        </Text>

        <Box
          fontFamily="var(--FedraSansStd-book)"
          borderRadius="0"
          display={'flex'}
          textAlign="center"
          color="#FEFAF6"
          flexWrap="wrap"
          justifyContent="center"
          gap={4}
        >
          {buttons.map(button => (
            <Button
              key={button.id}
              as={Link}
              fontSize={{ base: '.875rem', md: '1.125rem' }}
              fontWeight={400}
              lineHeight={{ base: '1.4rem', md: '1.8rem' }}
              bg="#1A1D21"
              px={{ base: 4, md: 6 }}
              maxHeight={{ base: '30px', md: '45px' }}
              py={{ base: 1, md: 2 }}
              borderRadius="0"
              border={'none'}
              color="#FEFAF6"
              _hover={{
                textDecoration: 'none',
              }}
              href={refineUrlDomain(button.linkUrl, region, lang)}
              prefetch
            >
              {button.buttonText}
            </Button>
          ))}
        </Box>
      </Flex>
    </Box>
  );
};

export default ExploreTags;
